"use strict";
exports.__esModule = true;
exports.SET_ERROR_LANGUAGES = exports.SET_DELETE_MODAL_ACTIVE = exports.RESET_GLOBAL_CONSTANT_DATA = exports.UPDATE_GLOBAL_CONSTANT_DATA = exports.SET_GLOBAL_CONSTANT_DATA = exports.SET_CURRENT_HYBRID_LANGUAGE = exports.SET_CURRENT_LANGUAGE = exports.SET_ADD_MODAL_ACTIVE = void 0;
exports.SET_ADD_MODAL_ACTIVE = 'SET_ADD_MODAL_ACTIVE';
exports.SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';
exports.SET_CURRENT_HYBRID_LANGUAGE = 'SET_CURRENT_HYBRID_LANGUAGE';
exports.SET_GLOBAL_CONSTANT_DATA = 'SET_GLOBAL_CONSTANT_DATA';
exports.UPDATE_GLOBAL_CONSTANT_DATA = 'UPDATE_GLOBAL_CONSTANT_DATA';
exports.RESET_GLOBAL_CONSTANT_DATA = 'RESET_GLOBAL_CONSTANT_DATA';
exports.SET_DELETE_MODAL_ACTIVE = 'SET_DELETE_MODAL_ACTIVE';
exports.SET_ERROR_LANGUAGES = 'SET_ERROR_LANGUAGES';
